import { createSlice } from '@reduxjs/toolkit';

export const uploadImageSlice = createSlice({
  name: 'uploadImage',
  initialState: {
    uploadedImage: {
      base64String: '',
      fileName: '',
    },
    image_description: [],
    uploadImageLoading: false,
    uploadImageError: false,
    uploadImageErrorMessage: '',
  },
  reducers: {
    setUploadedImage: (state, action) => {
      state.uploadedImage.base64String = action.payload.base64String;
      state.uploadedImage.fileName = action.payload.fileName;
    },
    setUploadImageLoading: (state, action) => {
      state.uploadImageLoading = action.payload;
      state.uploadImageError = false;
      state.uploadImageErrorMessage = '';
    },
    setUploadImageDescription: (state, action) => {
      state.image_description = action.payload;
      state.uploadImageLoading = false;
      state.uploadImageError = false;
      state.uploadImageErrorMessage = '';
    },
    setUploadImageError: (state, action) => {
      state.uploadImageError = true;
      state.uploadImageErrorMessage = action.payload;
      state.uploadImageLoading = false;
    },
    setClearUploadImageError: (state) => {
      state.uploadImageError = false;
      state.uploadImageErrorMessage = '';
    },
    setClearImageDiscription: (state) => {
      state.image_description = [];
    }
  },
});

export const {
  setUploadedImage,
  setUploadImageLoading,
  setUploadImageDescription,
  setUploadImageError,
  setClearUploadImageError,
  setClearImageDiscription,
} = uploadImageSlice.actions;

export default uploadImageSlice.reducer;
